import React from 'react';
import capitalize from 'lodash/capitalize';
import { Card, Layout, Text } from '../components';
function Header({ children }) {
  return (
    <Text variant="body-small" bold>
      {children}
    </Text>
  );
}
export function PolicyCard({
  fullName,
  policyNumber,
  address: { line1, line2, line3 },
  policyTerm,
}) {
  return (
    <Card>
      <Layout display="flex" className="gap-1" padding="small">
        <div>
          <Header>Customer name</Header>
          <Text
            color="foreground-secondary"
            variant="body-small"
            data-testid="Cancellations_text_fullName"
          >
            {fullName}
          </Text>
        </div>
        <div>
          <Header>Policy number</Header>
          <Text
            color="foreground-secondary"
            variant="body-small"
            data-testid="Cancellations_text_policyNumber"
          >
            {policyNumber}
          </Text>
        </div>
        <div>
          <Header>Address</Header>
          <Text color="foreground-secondary" variant="body-small">
            {line1}
          </Text>
          <Text color="foreground-secondary" variant="body-small">
            {capitalize(line2) || null}
          </Text>
          <Text color="foreground-secondary" variant="body-small">
            {line3}
          </Text>
        </div>
        <div>
          <Header>Policy term</Header>
          <Text color="foreground-secondary" variant="body-small">
            {policyTerm}
          </Text>
        </div>
      </Layout>
    </Card>
  );
}
